import { tickerItems } from "@/mocks/suye";

export default function Hero() {
  return (
    <section id="top" className="relative">
      <div className="relative flex min-h-[92vh] w-full flex-col overflow-hidden bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20editorial%20collage%20of%20trending%20hot%20topics%20with%20megaphone%2C%20newspaper%20clippings%20and%20light%20spots%2C%20abstract%20vermillion%20cream%20and%20deep%20amber%20tones%2C%20dramatic%20magazine%20cover%20style%2C%20textured%20paper%2C%20high%20contrast%20cinematic%20lighting&width=1600&height=900&seq=hero-2026&orientation=landscape"
          alt="宿野吃瓜 实时热点现场围观背景"
          className="absolute inset-0 h-full w-full object-cover object-center opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85" />

        <div className="relative z-10 mx-auto flex w-full max-w-[1080px] flex-1 flex-col items-center justify-center px-4 py-28 text-center md:px-6 md:py-36">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm">
            <span className="pulse-dot h-2 w-2 rounded-full bg-primary-500" />
            全网热点 · 现场围观 · 实时刷新
          </span>

          <h1 className="mt-8 font-heading text-4xl font-black leading-[1.15] tracking-tight text-background-50 md:text-6xl md:leading-[1.12]">
            前排板凳坐稳，
            <br className="hidden md:block" />
            <span className="text-primary-500">这一波瓜</span>正在热播
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200/95 md:text-lg">
            宿野吃瓜把散落在各个平台的热议事件、进展时间线与围观讨论聚到一起，帮你随时刷新看进展、快速了解来龙去脉。想前排围观、追直播动态，这里都有。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#live"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 shadow-lg transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-fill" />
              现在去现场围观
            </a>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/5 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:border-background-50/50 hover:bg-background-50/10"
            >
              <i className="ri-fire-fill text-accent-400" />
              看看实时热榜
            </a>
          </div>

          <dl className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-3 md:gap-6">
            {[
              { k: "今日更新", v: "268", u: "条进展", icon: "ri-refresh-line" },
              { k: "在线围观", v: "4.2w", u: "前排同好", icon: "ri-team-fill" },
              { k: "累计热榜", v: "3000+", u: "条话题", icon: "ri-fire-line" },
            ].map((s) => (
              <div
                key={s.k}
                className="rounded-2xl border border-background-50/15 bg-background-50/5 px-3 py-4 backdrop-blur-sm md:px-5 md:py-5"
              >
                <dt className="flex items-center justify-center gap-1.5 text-[11px] text-background-300 md:text-xs">
                  <i className={s.icon} />
                  {s.k}
                </dt>
                <dd className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
                  {s.v}
                  <span className="ml-1 text-xs font-medium text-accent-400">{s.u}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="relative z-10 border-y border-background-100 bg-background-50">
        <div className="flex items-center overflow-hidden">
          <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 text-background-50 md:px-6">
            <span className="pulse-dot h-2 w-2 rounded-full bg-background-50" />
            <span className="text-xs font-bold tracking-[0.18em] md:text-sm">快讯</span>
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track items-center gap-12 px-6 py-3.5">
              {[...tickerItems, ...tickerItems].map((t, idx) => (
                <span key={idx} className="flex shrink-0 items-center gap-3 text-sm text-foreground-800">
                  <i className="ri-radio-button-line text-accent-600" />
                  {t}
                </span>
              ))}
            </div>
          </div>
          <a
            href="#live"
            className="hidden shrink-0 items-center gap-1.5 border-l border-background-200 px-5 py-3 text-xs font-medium text-primary-700 hover:bg-background-100 md:flex"
          >
            全部进展 <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}